import React, { useContext } from 'react'
import { Upselling } from '../../components/upselling/upselling'
import { useNavigate } from 'react-router-dom'
import { track } from '../../ClevertapWrapper'
import routes from '../../router/routes'
import { clevertapEvents } from '../../labels'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useUpselling } from '../../hooks/useUpselling'

export function Settlement() {
    const upselling = useUpselling()

    const navigation = useNavigate()

    const { features } = useContext(FeatureContext)

    const handlerNavigate = (route: string, _track?: string) => {
        if (_track) {
            track(_track)
        }

        navigation(route)
    }

    const goBtn = () => {
        upselling.updateUpselling('settlement', true)
        handlerNavigate(
            `/${routes.products}/${routes.liquidate}`,
            clevertapEvents.drawerLiquidate
        )
    }

    return (
        <Upselling
            active={features.settlement}
            feature={{
                image: require('../../assets/images/upselling/settlement.png'),
                title: 'Ya estas reduciendo tus mermas, Salvando Productos',
                btn: {
                    title: 'Ir a liquidaciones',
                    action: () => {
                        goBtn()
                    },
                },
            }}
            pending={{
                headtitle: 'Liquida Productos Próximos a Vencer',
                title: 'Evita pérdidas mientras sumas ganancias',
                text: 'Maximiza tus ingresos con la funcionalidad de liquidación de productos próximos a vencer de amiPOS. Publica descuentos especiales y vende esos productos antes de que sea tarde.',
                list: [
                    'Publica productos con descuentos superiores al 40%',
                    'Aumenta tus ventas y reduce el desperdicio',
                    'Notifica a clientes locales sobre ofertas inmediatas',
                    'Gestiona las liquidaciones fácilmente desde amiPOS',
                    'Aprovecha cada oportunidad de venta antes del vencimiento',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigation('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/settlement.png'),
                contract: 'contratando el Plan Estándar y Pro',
            }}
        />
    )
}
